import { useAuth } from './auth';
import { config } from './config';
import { Button, Spinner } from './ui';
import { KeysPage } from './pages/Keys';

export function App() {
  const { status, user, error, login, logout } = useAuth();

  if (status === 'loading') {
    return (
      <div className="center">
        <Spinner />
      </div>
    );
  }

  if (status !== 'authenticated' || !user) {
    return <Login onLogin={login} error={error} />;
  }

  const email = (user.profile.email as string | undefined) ?? '';
  const name = (user.profile.name as string | undefined) ?? email;
  const initial = (name || 'P').trim().charAt(0).toUpperCase();

  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand">
          <span className="brand__glyph" aria-hidden />
          <span className="brand__word">
            Prism<b>Tx</b>
          </span>
        </div>
        <div className="topbar__user">
          <span className="topbar__email">{email}</span>
          <span className="avatar" aria-hidden>
            {initial}
          </span>
          <Button variant="ghost" small onClick={logout}>
            Sign out
          </Button>
        </div>
      </header>
      <main className="content">
        <KeysPage />
      </main>
    </div>
  );
}

function Login({ onLogin, error }: { onLogin: () => void; error?: string }) {
  const misconfigured = !config.oidc.clientId;
  return (
    <div className="center">
      <div className="login">
        <span className="login__glyph" aria-hidden />
        <div>
          <h1>PrismTx Dashboard</h1>
          <p>Manage the API keys your agents use to reach the PrismTx platform.</p>
        </div>
        <Button variant="primary" onClick={onLogin} disabled={misconfigured}>
          Sign in
        </Button>
        {misconfigured && (
          <div className="notice notice--danger">
            VITE_OIDC_CLIENT_ID is not set — the app can’t start a login. See{' '}
            <code>.env.example</code>.
          </div>
        )}
        {error && !misconfigured && <div className="notice notice--danger">{error}</div>}
      </div>
    </div>
  );
}
